import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './styles/globals.css'

console.log("main.tsx is loading...");

const container = document.getElementById('root')

if (!container) {
  throw new Error('Root element not found')
}

console.log("Root element found, creating React root...");

try {
  const root = createRoot(container)
  
  console.log("React root created, rendering App...");
  
  root.render(
    <StrictMode>
      <App />
    </StrictMode>,
  )
  
  console.log("App rendered successfully!");
} catch (error) {
  console.error("Error rendering React app:", error);
  
  // Fallback: show error message in the DOM
  const errorMessage = error instanceof Error ? error.message : 'Unknown error';
  container.innerHTML = `
    <div style="background: red; color: white; padding: 20px; text-align: center;">
      <h1>React Error!</h1>
      <p>Error: ${errorMessage}</p>
      <p>Check the console for more details.</p>
    </div>
  `;
}